import Button from "./button";
import InputField from "./inputField";
import uploadIcon from "@assets/icons/upload.svg";
import { openMailto } from "@/utils/mailto";

const RequestCommericalProposalForm = () => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const businessName = formData.get("businessName");
    const email = formData.get("email");
    const phone = formData.get("phone");
    const operationType = formData.get("operationType");
    const kitchens = formData.get("kitchens");
    const operatingHours = formData.get("operatingHours");
    const contactPerson = formData.get("contactPerson");

    const body = `Hello,

      A request for a commercial gas proposal has been submitted.

      Business Name: ${businessName}
      Email Address: ${email}
      Phone Number: ${phone}

      Type of Operation: ${operationType}
      Number of Kitchens: ${kitchens}
      Operating Hours: ${operatingHours}
      Contact Person: ${contactPerson}

      Thank you.`;

    openMailto({
      subject: `Commercial Gas Proposal Request - ${businessName}`,
      body,
    });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="mt-6 md:mt-12 bg-white rounded-[12px] md:rounded-[24px] px-5 md:px-10 lg:px-[100px] py-5 md:py-10 lg:py-20 space-y-6 md:space-y-8 w-full"
    >
      <InputField
        label="Business Name"
        placeholder="Enter your business name"
        name="businessName"
        required
      />

      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Email Address"
          placeholder="Enter your email address"
          type="email"
          name="email"
          required
        />

        <InputField
          label="Phone Number"
          placeholder="Enter your phone number"
          type="tel"
          name="phone"
          required
        />
      </div>

      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Type of Operation"
          placeholder="Select type of operation"
          as="select"
          name="operationType"
          required
          options={[
            { label: "Residential", value: "Residential" },
            { label: "Business", value: "Business" },
          ]}
        />

        <InputField
          label="Number of Kitchen"
          placeholder="Enter the number of kitchen"
          type="number"
          name="kitchens"
          required
        />
      </div>

      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Operating Hours"
          placeholder="Enter your operating hours"
          name="operatingHours"
          required
        />

        <InputField
          label="Contact Person"
          placeholder="Enter contact person"
          name="contactPerson"
          required
        />
      </div>

      <div>
        <label className="text-sm md:text-lg lg:text-xl text-[#0A0E2EBF] font-medium block mb-2 md:mb-3">
          Upload Layout Drawings (optional)
        </label>

        <div className="bg-[#F1F1F1] border border-[#62636C] border-dashed rounded-md md:rounded-lg h-[173px] w-full grid place-content-center relative">
          <input
            type="file"
            name="layoutDrawings"
            className="absolute inset-0 opacity-0 cursor-pointer"
          />

          <div>
            <img src={uploadIcon} alt="upload icon" className="mx-auto" />
            <span className="text-[#62636C] text-xs md:text-lg block text-center mt-6">
              Upload layout drawings
            </span>
          </div>
        </div>
      </div>

      <div className="flex justify-center pt-5">
        <Button title="Get Proposal" type="submit" />
      </div>
    </form>
  );
};

export default RequestCommericalProposalForm;
